import { render, staticRenderFns } from "./FAQModelChange.vue?vue&type=template&id=6791b366&scoped=true"
import script from "./FAQModelChange.vue?vue&type=script&lang=js"
export * from "./FAQModelChange.vue?vue&type=script&lang=js"
import style0 from "./FAQModelChange.vue?vue&type=style&index=0&id=6791b366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6791b366",
  null
  
)

export default component.exports